import Vue from 'vue';
import Vuex from 'vuex';
import outletDateFilter from './modules/outlet-date-filters';
import provider from './modules/provider';
import socket from './modules/socket';
import supplier from './modules/supplier';
import outlet from './modules/outlet';
// to be removed from here
import stockInventory from './modules/stock-inventory';
import tag from './modules/tag';
import { createVuexLoader } from 'vuex-loading';

const VuexLoading = createVuexLoader({
    moduleName: 'loader',
    componentName: 'v-loading',
    className: 'v-loading',
});

Vue.use(Vuex);
Vue.use(VuexLoading);

export default new Vuex.Store({
    plugins: [VuexLoading.Store],
    modules: {
        outletDateFilter,
        provider,
        socket,
        // stockInventory,
        supplier,
        outlet,
        tag,
    },
});



// WEBPACK FOOTER //
// ./resources/assets/js/store/index.js